export const getValidImageDpi = (dpi: number | null | undefined): number | undefined => {
  return typeof dpi === 'number' && Number.isFinite(dpi) && dpi > 0 ? dpi : undefined;
};

export const getImageSizeAtDpi = (
  width: number,
  height: number,
  dpi: number | null | undefined,
  unitsPerInch: number,
): { width: number, height: number } | undefined => {
  const validDpi = getValidImageDpi(dpi);
  if (validDpi === undefined || !Number.isFinite(unitsPerInch) || unitsPerInch <= 0) return undefined;

  const size = { width: width * unitsPerInch / validDpi, height: height * unitsPerInch / validDpi };
  return Number.isFinite(size.width) && Number.isFinite(size.height) && size.width > 0 && size.height > 0
    ? size
    : undefined;
};
